import { Suspense, lazy, ElementType } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const RegisterPage = Loadable(lazy(() => import('../pages/auth/RegisterPage')));
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPasswordPage')));
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')));
export const VerificationPage = Loadable(lazy(() => import('../pages/auth/VerificationPage')));
export const RegistrationComplete = Loadable(
  lazy(() => import('../pages/auth/RegistrationComplete'))
);
export const UserInactive = Loadable(lazy(() => import('../pages/auth/UserInactive')));

export const PaymentSuccessPage = Loadable(lazy(() => import('../pages/payment/Success')));
export const PaymentFailPage = Loadable(lazy(() => import('../pages/payment/Fail')));
export const PaymentStatusPage = Loadable(lazy(() => import('../pages/payment/Status')));
export const Main = Loadable(lazy(() => import('../pages/Main')));
export const Publishers = Loadable(lazy(() => import('../pages/Publishers')));
export const Sites = Loadable(lazy(() => import('../pages/Sites')));
export const SitesAll = Loadable(lazy(() => import('../pages/SitesAll')));
export const Advertisers = Loadable(lazy(() => import('../pages/Advertisers')));
export const Campaigns = Loadable(lazy(() => import('../pages/Campaigns')));
export const CampaignsAll = Loadable(lazy(() => import('../pages/CampaignsAll')));
export const PublisherEdit = Loadable(lazy(() => import('../pages/PublisherEdit')));
export const AdvertiserEdit = Loadable(lazy(() => import('../pages/AdvertiserEdit')));
export const Users = Loadable(lazy(() => import('../pages/Users')));
export const UserEdit = Loadable(lazy(() => import('../pages/UserEdit')));
export const SiteEdit = Loadable(lazy(() => import('../pages/SiteEdit')));
export const CampaignEdit = Loadable(lazy(() => import('../pages/CampaignEdit')));
export const Report = Loadable(lazy(() => import('../pages/Report')));
export const ReportRequests = Loadable(lazy(() => import('../pages/ReportRequests')));
export const ReportFeedRate = Loadable(lazy(() => import('../pages/ReportFeedRate')));
export const ReportClickRate = Loadable(lazy(() => import('../pages/ReportClickRate')));
export const Audit = Loadable(lazy(() => import('../pages/Audit')));
export const Profile = Loadable(lazy(() => import('../pages/Profile')));
export const Settings = Loadable(lazy(() => import('../pages/Settings')));
export const Api = Loadable(lazy(() => import('../pages/Api')));
export const Finance = Loadable(lazy(() => import('../pages/Finance')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
